<div *ngIf="!simulationPreviewLoaded" class="simulation-loader">
  <ng-container *ngIf="simulationPreviewLoadError; else loader">
          The simulation preview could not be loaded
  </ng-container>
  <ng-template #loader>
      <mat-spinner [diameter]="50"></mat-spinner>
  </ng-template>
</div>
<div [@fadeInOutA-Scene]="simulationPreviewLoaded ? 1 : 0" id="simulation-preview">
  <iframe [style.visibility]="!simulationPreviewLoaded ? 'hidden': 'visible'" id="simulation-preview-frame" #simulationPreview scrolling="no" frameborder="0" [src]="simulationPreviewUrl" allow="microphone"></iframe>
</div>